import React from 'react';
import AnalyticsRender from './AnalyticsRender';

export const Analytics = ():JSX.Element=>{

	return <AnalyticsRender />;
};